import { useEffect } from 'react';
import Loading from 'components/loading';
import { useGetLoanQuery, useSetAcceptedBizOsAccountMutation } from 'generated/graphql';
import { useNavigation } from 'hooks/index';
import { getLoanApplicationParams } from 'utils/utils';

type ChooseBankAccountProps = {
    nextScreen(): void;
};

const ChooseBankAccount = ({ nextScreen }: ChooseBankAccountProps) => {
    const [acceptedBizOsAccountMutation] = useSetAcceptedBizOsAccountMutation();
    const { goToDocumentCheckout } = useNavigation();
    const loanApplicationId = getLoanApplicationParams();

    const { data: { loanApplication } } = useGetLoanQuery({
        variables: {
            id: loanApplicationId
        },
        fetchPolicy: "cache-first"
    });

    useEffect(() => {
        if (loanApplication) {
            if (loanApplication.acceptedBizOsAccount !== null) {
                goToDocumentCheckout();
            } else {
                handleSetAcceptedBizOsAccount()
            }
        }
    }, [loanApplication]);

    const handleSetAcceptedBizOsAccount = async () => {
        try {
            await acceptedBizOsAccountMutation({
                variables: {
                    acceptedBizOsAccount: false,
                    id: loanApplicationId,
                }
            });
            nextScreen();
        } catch (error) {
            console.log(error);
        }
    };

    return (
        <Loading />
    );
}

export default ChooseBankAccount;
